/* eslint-disable */
// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Chapter__Navigation__ComponentController from "../../components/chapter/navigation/component_controller"
application.register("chapter--navigation--component", Chapter__Navigation__ComponentController)

import Chapter__TextCustomization__ComponentController from "../../components/chapter/text_customization/component_controller"
application.register("chapter--text-customization--component", Chapter__TextCustomization__ComponentController)

import Form__Select__ComponentController from "../../components/form/select/component_controller"
application.register("form--select--component", Form__Select__ComponentController)

import Form__TextEditor__WordCount__ComponentController from "../../components/form/text_editor/word_count/component_controller"
application.register("form--text-editor--word-count--component", Form__TextEditor__WordCount__ComponentController)

import Form__TextList__ComponentController from "../../components/form/text_list/component_controller"
application.register("form--text-list--component", Form__TextList__ComponentController)

import LottieAnimation__ComponentController from "../../components/lottie_animation/component_controller"
application.register("lottie-animation--component", LottieAnimation__ComponentController)

import Navbar__Link__TextCustomization__ComponentController from "../../components/navbar/link/text_customization/component_controller"
application.register("navbar--link--text-customization--component", Navbar__Link__TextCustomization__ComponentController)

import Navbar__Modal__Resources__ComponentController from "../../components/navbar/modal/resources/component_controller"
application.register("navbar--modal--resources--component", Navbar__Modal__Resources__ComponentController)

import Primer__Button__ComponentController from "../../components/primer/button/component_controller"
application.register("primer--button--component", Primer__Button__ComponentController)

import Primer__Checkbox__ComponentController from "../../components/primer/checkbox/component_controller"
application.register("primer--checkbox--component", Primer__Checkbox__ComponentController)

import Primer__Clipboard__ComponentController from "../../components/primer/clipboard/component_controller"
application.register("primer--clipboard--component", Primer__Clipboard__ComponentController)

import Primer__Collapse__ComponentController from "../../components/primer/collapse/component_controller"
application.register("primer--collapse--component", Primer__Collapse__ComponentController)

import Primer__Icon__ComponentController from "../../components/primer/icon/component_controller"
application.register("primer--icon--component", Primer__Icon__ComponentController)

import Primer__Modal__ComponentController from "../../components/primer/modal/component_controller"
application.register("primer--modal--component", Primer__Modal__ComponentController)

import Primer__ProgressiveDisplay__ComponentController from "../../components/primer/progressive_display/component_controller"
application.register("primer--progressive-display--component", Primer__ProgressiveDisplay__ComponentController)

import Primer__TextToSpeech__ComponentController from "../../components/primer/text_to_speech/component_controller"
application.register("primer--text-to-speech--component", Primer__TextToSpeech__ComponentController)

import Primer__Tooltip__ComponentController from "../../components/primer/tooltip/component_controller"
application.register("primer--tooltip--component", Primer__Tooltip__ComponentController)

import Writing__ComponentController from "../../components/writing/component_controller"
application.register("writing--component", Writing__ComponentController)

import Writing__State__Accomplished__ComponentController from "../../components/writing/state/accomplished/component_controller"
application.register("writing--state--accomplished--component", Writing__State__Accomplished__ComponentController)

import Writing__State__Completed__ComponentController from "../../components/writing/state/completed/component_controller"
application.register("writing--state--completed--component", Writing__State__Completed__ComponentController)

import Writing__State__Composable__ComponentController from "../../components/writing/state/composable/component_controller"
application.register("writing--state--composable--component", Writing__State__Composable__ComponentController)

import Writing__State__Edition__ComponentController from "../../components/writing/state/edition/component_controller"
application.register("writing--state--edition--component", Writing__State__Edition__ComponentController)

import Writing__WordCount__ComponentController from "../../components/writing/word_count/component_controller"
application.register("writing--word-count--component", Writing__WordCount__ComponentController)

import Activities__HighlighterController from "./activities/highlighter_controller"
application.register("activities--highlighter", Activities__HighlighterController)

import AjaxController from "./ajax_controller"
application.register("ajax", AjaxController)

import AnalyticsController from "./analytics_controller"
application.register("analytics", AnalyticsController)

import AnimateController from "./animate_controller"
application.register("animate", AnimateController)

import AnimeController from "./anime_controller"
application.register("anime", AnimeController)

import ApplicationController from "./application_controller"
application.register("application", ApplicationController)

import AutoAnimateController from "./auto-animate_controller"
application.register("auto-animate", AutoAnimateController)

import AutoClickController from "./auto-click_controller"
application.register("auto-click", AutoClickController)

import AutoResizeController from "./auto-resize_controller"
application.register("auto-resize", AutoResizeController)

import AutoFormSubmitController from "./auto_form_submit_controller"
application.register("auto-form-submit", AutoFormSubmitController)

import AutofocusController from "./autofocus_controller"
application.register("autofocus", AutofocusController)

import AvatarController from "./avatar_controller"
application.register("avatar", AvatarController)

import BatchSelectController from "./batch_select_controller"
application.register("batch-select", BatchSelectController)

import BindController from "./bind_controller"
application.register("bind", BindController)

import BubbleSliderController from "./bubble_slider_controller"
application.register("bubble-slider", BubbleSliderController)

import BusterController from "./buster_controller"
application.register("buster", BusterController)

import CancelReasonsController from "./cancel-reasons_controller"
application.register("cancel-reasons", CancelReasonsController)

import CardsRowController from "./cards-row_controller"
application.register("cards-row", CardsRowController)

import CharacterCounterController from "./character-counter_controller"
application.register("character-counter", CharacterCounterController)

import ChartjsController from "./chartjs_controller"
application.register("chartjs", ChartjsController)

import CheckAllController from "./check-all_controller"
application.register("check-all", CheckAllController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CmykController from "./cmyk_controller"
application.register("cmyk", CmykController)

import ConfettiController from "./confetti_controller"
application.register("confetti", ConfettiController)

import ContestParticipationFormController from "./contest_participation_form_controller"
application.register("contest-participation-form", ContestParticipationFormController)

import CopyController from "./copy_controller"
application.register("copy", CopyController)

import CorrectionController from "./correction_controller"
application.register("correction", CorrectionController)

import CountdownController from "./countdown_controller"
application.register("countdown", CountdownController)

import CouponController from "./coupon_controller"
application.register("coupon", CouponController)

import CrispController from "./crisp_controller"
application.register("crisp", CrispController)

import CssController from "./css_controller"
application.register("css", CssController)

import CustomizeController from "./customize_controller"
application.register("customize", CustomizeController)

import DiffController from "./diff_controller"
application.register("diff", DiffController)

import DraggableController from "./draggable_controller"
application.register("draggable", DraggableController)

import DrawerController from "./drawer_controller"
application.register("drawer", DrawerController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import EditorController from "./editor_controller"
application.register("editor", EditorController)

import EmailConsentController from "./email-consent_controller"
application.register("email-consent", EmailConsentController)

import EventController from "./event_controller"
application.register("event", EventController)

import ExpandableController from "./expandable_controller"
application.register("expandable", ExpandableController)

import FieldTagsController from "./field_tags_controller"
application.register("field-tags", FieldTagsController)

import FormController from "./form_controller"
application.register("form", FormController)

import FormWizardController from "./form_wizard_controller"
application.register("form-wizard", FormWizardController)

import FullscreenController from "./fullscreen_controller"
application.register("fullscreen", FullscreenController)

import Games__AcrosticheController from "./games/acrostiche_controller"
application.register("games--acrostiche", Games__AcrosticheController)

import Games__DescribeController from "./games/describe_controller"
application.register("games--describe", Games__DescribeController)

import Games__GameController from "./games/game_controller"
application.register("games--game", Games__GameController)

import Games__IntruderController from "./games/intruder_controller"
application.register("games--intruder", Games__IntruderController)

import Games__PunctuationController from "./games/punctuation_controller"
application.register("games--punctuation", Games__PunctuationController)

import Games__SortSentenceController from "./games/sort-sentence_controller"
application.register("games--sort-sentence", Games__SortSentenceController)

import GiftCardController from "./gift_card_controller"
application.register("gift-card", GiftCardController)

import GradesController from "./grades_controller"
application.register("grades", GradesController)

import GtmController from "./gtm_controller"
application.register("gtm", GtmController)

import HighlightElementsController from "./highlight-elements_controller"
application.register("highlight-elements", HighlightElementsController)

import HovercardController from "./hovercard_controller"
application.register("hovercard", HovercardController)

import HtmlController from "./html_controller"
application.register("html", HtmlController)

import IframeController from "./iframe_controller"
application.register("iframe", IframeController)

import ImmersiveReaderController from "./immersive_reader_controller"
application.register("immersive-reader", ImmersiveReaderController)

import IntlTelInputController from "./intl-tel-input_controller"
application.register("intl-tel-input", IntlTelInputController)

import IntroductionPageController from "./introduction-page_controller"
application.register("introduction-page", IntroductionPageController)

import KeystrokesController from "./keystrokes_controller"
application.register("keystrokes", KeystrokesController)

import MailcheckController from "./mailcheck_controller"
application.register("mailcheck", MailcheckController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MultiLinesFormController from "./multi-lines-form_controller"
application.register("multi-lines-form", MultiLinesFormController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import NavigationController from "./navigation_controller"
application.register("navigation", NavigationController)

import NewsletterController from "./newsletter_controller"
application.register("newsletter", NewsletterController)

import NotificationStackController from "./notification_stack_controller"
application.register("notification-stack", NotificationStackController)

import OrderController from "./order_controller"
application.register("order", OrderController)

import PixelController from "./pixel_controller"
application.register("pixel", PixelController)

import PlayerController from "./player_controller"
application.register("player", PlayerController)

import PollingStatusController from "./polling-status_controller"
application.register("polling-status", PollingStatusController)

import PopupZoneController from "./popup-zone_controller"
application.register("popup-zone", PopupZoneController)

import PreventSelectController from "./prevent-select_controller"
application.register("prevent-select", PreventSelectController)

import Primer__DropdownController from "./primer/dropdown_controller"
application.register("primer--dropdown", Primer__DropdownController)

import Primer__ToastController from "./primer/toast_controller"
application.register("primer--toast", Primer__ToastController)

import PrintController from "./print_controller"
application.register("print", PrintController)

import ProductTourController from "./product_tour_controller"
application.register("product-tour", ProductTourController)

import QuestionController from "./question_controller"
application.register("question", QuestionController)

import RandomController from "./random_controller"
application.register("random", RandomController)

import RemoveUrlParamsController from "./remove-url-params_controller"
application.register("remove-url-params", RemoveUrlParamsController)

import ResizeImageController from "./resize_image_controller"
application.register("resize-image", ResizeImageController)

import ReviewEditorController from "./review_editor_controller"
application.register("review-editor", ReviewEditorController)

import RnWebviewController from "./rn-webview_controller"
application.register("rn-webview", RnWebviewController)

import SchoolAutocompleteController from "./school_autocomplete_controller"
application.register("school-autocomplete", SchoolAutocompleteController)

import SelectController from "./select_controller"
application.register("select", SelectController)

import ShopifyController from "./shopify_controller"
application.register("shopify", ShopifyController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SignOutController from "./sign-out_controller"
application.register("sign-out", SignOutController)

import SlideInController from "./slide_in_controller"
application.register("slide-in", SlideInController)

import SmoothAppearController from "./smooth-appear_controller"
application.register("smooth-appear", SmoothAppearController)

import SmoothScrollController from "./smooth-scroll_controller"
application.register("smooth-scroll", SmoothScrollController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import SoundController from "./sound_controller"
application.register("sound", SoundController)

import SpinnerController from "./spinner_controller"
application.register("spinner", SpinnerController)

import StripeElementsController from "./stripe-elements_controller"
application.register("stripe-elements", StripeElementsController)

import SubscriptionSelectorController from "./subscription-selector_controller"
application.register("subscription-selector", SubscriptionSelectorController)

import SwiperController from "./swiper_controller"
application.register("swiper", SwiperController)

import TabsAnchorController from "./tabs-anchor_controller"
application.register("tabs-anchor", TabsAnchorController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TeleportController from "./teleport_controller"
application.register("teleport", TeleportController)

import TextFieldController from "./text_field_controller"
application.register("text-field", TextFieldController)

import TextareaTagsController from "./textarea_tags_controller"
application.register("textarea-tags", TextareaTagsController)

import TipTapController from "./tip-tap_controller"
application.register("tip-tap", TipTapController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import TransitionController from "./transition_controller"
application.register("transition", TransitionController)

import TurboLazyLoadController from "./turbo-lazy-load_controller"
application.register("turbo-lazy-load", TurboLazyLoadController)

import ValidationController from "./validation_controller"
application.register("validation", ValidationController)

import VimeoController from "./vimeo_controller"
application.register("vimeo", VimeoController)

import WishCardController from "./wish-card_controller"
application.register("wish-card", WishCardController)

import WordCountConditionController from "./word-count-condition_controller"
application.register("word-count-condition", WordCountConditionController)

import WritingAssistantController from "./writing_assistant_controller"
application.register("writing-assistant", WritingAssistantController)

import WritingController from "./writing_controller"
application.register("writing", WritingController)

requestAnimationFrame(() => {
  document.documentElement.setAttribute('stimulus-connected', '')
})
